var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.notifications.length)?_c('a-affix',{staticClass:"app-notifications",attrs:{"offset-top":10}},_vm._l((_vm.notifications),function(notification){return _c('notification',{key:notification.id,attrs:{"notification":notification},on:{"notification-closed":_vm.removeNotification}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }